(function($, window) {
    (()=>{
        // console.log('test');
    })();
})(jQuery);
